// Leader cards; their effects are not implemented yet
const LeaderNames =
{
    // Age A
    AlexanderTheGreat: "Alexander the Great",
    Aristotle: "Aristotle",
    Hammurabi: "Hammurabi",
    Homer: "Homer",
    JuliusCaesar: "Julius Caesar",
    Moses: "Moses",
    // Age A (New Wonders and Leaders)
    Boudica: "Boudica",
    Cleopatra: "Cleopatra",
    Hippocrates: "Hippocrates",
    Confucius: "Confucius",
    SunTzu: "Sun Tzu",
    Ashoka: "Ashoka",
    // Age I
    ChristopherColumbus: "Christopher Columbus",
    FrederickBarbarossa: "Frederick Barbarossa",
    GenghisKhan: "Genghis Khan",
    JoanOfArc: "Joan of Arc",
    LeonardoDaVinci: "Leonardo Da Vinci",
    Michelangelo: "Michelangelo",
    // Age I (New Wonders and Leaders)
    IsabellaOfCastile: "Isabella of Castile",
    EleanorOfAquitaine: "Eleanor of Aquitaine",
    JanZizka: "Jan Žižka",
    Nostradamus: "Nostradamus",
    JohannesGutenberg: "Johannes Gutenberg",
    Saladin: "Saladin",
    // Age II
    IsaacNewton: "Isaac Newton",
    JamesCook: "James Cook",
    JohannesSebastianBach: "Johannes Sebastian Bach",
    MaximillienRobespierre: "Maximillien Robespierre",
    NapoleonBonaparte: "Napoleon Bonaparte",
    WilliamShakespeare: "William Shakespeare",
    // Age II (New Wonders and Leaders)
    CatherineTheGreat: "Catherine the Great",
    MariaTheresa: "Maria Theresa",
    JamesWatt: "James Watt",
    AlfredNobel: "Alfred Nobel",
    AntoniGaudi: "Antoni Gaudí",
    CharlesDarwin: "Charles Darwin",
    // Age III
    AlbertEinstein: "Albert Einstein",
    BillGates: "Bill Gates",
    CharlesChaplin: "Charles Chaplin",
    MahatmaGandhi: "Mahatma Gandhi",
    SidMeier: "Sid Meier",
    WinstonChurchill: "Winston Churchill",
    // Age III (New Wonders and Leaders)
    MarieCurie: "Marie Curie Sklodowska",
    MarleneDietrich: "Marlene Dietrich",
    SteveJobs: "Steve Jobs",
    NelsonMandela: "Nelson Mandela",
    PierreDeCoubertin: "Pierre de Coubertin",
    IanFleming: "Ian Fleming",
}

module.exports = LeaderNames;